<template>
  <a-card>
    <x-table ref="personelTbl" class="mt-4" v-if="contractTypes && work_units" :key="changeModel"
             :model="model">
      <template slot="gender" slot-scope="text,record">
        {{text.record.personnel.proposal.gender_str}}
      </template>
      <template slot="work_unit" slot-scope="text,record">
        {{findWorkUnit(text.record.work_unit)}}
      </template>
  </x-table>
  </a-card>
</template>

<script>
import model from './conractModel'
import XTable from "@/components/new-x-table/XTable";
import axios from "@/axios";
export default {
  name: "list",
  data(){
    return{
      model,
      contractTypes: undefined,
      work_units: undefined,
      changeModel: 0,
    }
  },
  components: {
    XTable
  },
  async created(){
    await this.getTypes()
    await this.getUnits()
    console.log(this.model.cols,'modelllllllllllllllll')
    let help = this.model.cols.findIndex(x=> x.dataIndex == 'type_str')
    if (help > -1){
      console.log('daosdkajsk',this.model.cols[help].filterItems)
      this.model.cols[help].filterItems = this.contractTypes
    }
    help = this.model.cols.findIndex(x=> x.dataIndex == 'work_unit')
    if (help > -1){
      console.log('daosdkajsk',this.model.cols[help].filterItems)
      let units = {}
      this.work_units.map((x) => {units[x.id] = x.value})
      this.model.cols[help].filterItems = units
    }
    this.changeModel++
  },
  methods: {
    //get contract types
    async getTypes() {
      try {
        const {data} = await axios.get('/personnel/type/type')
        this.contractTypes = data
      } catch (e) {
        throw e
      }
    },
    async getUnits() {
      try {
        let {data} = await axios.get('/personnel/unit/unit')
        this.work_units = data
      } catch (e) {
        throw e
      }
    },
    //get work unit
    findWorkUnit(id){
      const unit = this.work_units.filter(x => x.id == id)
      if (unit[0]) return unit[0].value
    }
  }
}
</script>

<style scoped>

</style>